export const setPlatformControlState = /* GraphQL */ `
    mutation SetPlatformControlState($input: SetPlatformControlStateInput!) {
        setPlatformControlState(input: $input) {
            id
            state
            lastChangedBy
            lastChangedAt
            flipLatencySeconds
        }
    }
`;
